import { Avatar, Typography } from '@mui/material'
import React, { memo } from 'react'
import { useSmartTranslation } from '../../generic/hooks/useSmartTranslation'
import RuleNodeHandle from './RuleNodeHandle'
import { RuleColors, getColorFromResult } from './ruler_utils'
import DeleteNodeToolbar from './DeleteNodeToolbar'

const AnyAllNode = ({ data, selected }) => {
  const { t_ } = useSmartTranslation()

  const colors = data.any ? RuleColors.any : RuleColors.all

  return (

    <>
      <DeleteNodeToolbar handleNodeDelete={data.onNodeDelete} nodeId={data.nodeId} />
      <div className='conditionalNode' style={{ textAlign: 'center' }}>
        <Avatar sx={{ width: 56, height: 56, background: colors.background, border: (theme) => '0.2rem solid ' + (selected ? theme.palette.secondary.main : getColorFromResult(colors.border, data.testResult)) }} aria-label='add' variant={data.any ? 'rounded' : 'circular'}>
          <Typography fontSize='1.3rem' color='secondary' sx={{ margin: '56rem' }}>{data.any ? t_('Any') : t_('All')}</Typography>
        </Avatar>
        {!data.initial
          ? <RuleNodeHandle target />
          : null}
        <RuleNodeHandle target={false} />
      </div>
    </>
  )
}

export default memo(AnyAllNode)
